import React from 'react';

import { IP2GCoreComponentProps } from '@parcel2go/peacock-legacy-core/dist/types';
import { useP2GProfile } from '@parcel2go/peacock-legacy-profile/dist/contextProvider';
import { Tracking } from '../../services/api';
import { P2GBox } from '@parcel2go/peacock-legacy-core';

interface ICourierLogoProps extends IP2GCoreComponentProps {
    tracking: Tracking,
}

export const CourierLogo: React.FC<ICourierLogoProps> = (props) => {
    const profile = useP2GProfile();
    const providerId = profile.id.split('.').slice(0,1)

    if(providerId[0] === 'PARCEL2GO'){
        return (
            <P2GBox>
                <img 
                    src={`${profile.settings?.basePath as string}/logo/courier/${props.tracking.order.service.courierId}.normal-svg`} 
                    alt={`${props.tracking.order.service.courierName}-logo`} 
                    width={150}
            />
            </P2GBox>
        )
    } 
    return null;
}